<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 82 100">
    <g :fill="iconColor" fill-rule="evenodd">
      <path
        d="M20.049 65.12c.377-.296.566-.707.566-1.234s-.185-.934-.554-1.222c-.37-.287-.876-.43-1.518-.43h-2.868v3.328h2.868c.626 0 1.128-.147 1.506-.443"
      />
      <path
        d="M56.593 64.82v3.64h-6.337v6.898h-4.338V58.593h12.82v3.784h-8.482v2.443h6.337zM27.17 75.358V58.593h6.723c2.731 0 4.972.782 6.723 2.347 1.735 1.565 2.603 3.577 2.603 6.035 0 2.491-.868 4.511-2.603 6.06-1.719 1.549-3.96 2.323-6.723 2.323H27.17zm44.037 18.124H16.07c-2.287 0-4.148-1.85-4.148-4.125v-4.77h51.4c2.384 0 4.316-1.918 4.316-4.288v-26.01c0-2.37-1.932-4.29-4.315-4.29H11.922V10.644c0-2.269 1.861-4.119 4.148-4.119l37.957-.04V20.43c0 4.073 3.325 7.38 7.426 7.38l13.744-.039.154 61.586c0 2.275-1.857 4.125-4.144 4.125zm-59.87-34.89h7.52c1.895 0 3.389.488 4.481 1.461 1.109.975 1.663 2.236 1.663 3.785s-.554 2.818-1.663 3.808c-1.092.974-2.586 1.461-4.482 1.461h-3.18v6.251h-4.339V58.593zM56.48 0H16.07C10.166 0 5.36 4.779 5.36 10.643V50H4.316C1.932 50 0 51.92 0 54.289v26.01c0 2.37 1.932 4.288 4.315 4.288h1.046v4.77C5.36 95.227 10.166 100 16.07 100h55.137c5.901 0 10.706-4.773 10.706-10.643V25.19L56.48 0z"
      />
      <path
        d="M37.387 63.574c-.9-.798-2.169-1.197-3.807-1.197h-2.073v9.197h2.073c1.638 0 2.907-.399 3.807-1.198.9-.798 1.35-1.931 1.35-3.4 0-1.47-.45-2.603-1.35-3.402M25.675 39.845c-1.785 2.121-3.338 3.062-3.842 3.062-.414 0-.737-.108-.941-.204.161-.221.582-.625 1.678-1.264.874-.51 1.97-1.052 3.105-1.594zm9.229-9.035l.955-2.853c.476.505.98 1.023 1.507 1.546.193.191.61.577 1.234 1.121-1.402.322-2.735.67-3.982 1.038l.286-.852zM33.14 15.937c0-2.715.677-2.715 1.04-2.715.56 0 .674.023.76.155.282.433.282 1.923.282 2.413 0 .599-.499 2.339-.878 3.586-.79-1.377-1.204-2.553-1.204-3.439zm17.517 17.475a.923.923 0 0 1-.018.194c-.043.025-.219.095-.848.104-.111-.035-.404-.15-1.05-.535 1.329.032 1.77.16 1.916.237zM48.075 29.1c-.713 0-2.439.206-4.342.517-1.442-1.135-2.67-2.192-3.473-2.99a53.31 53.31 0 0 1-2.925-3.137c1.479-4.557 1.981-6.515 1.981-7.699 0-4.714-1.487-6.637-5.134-6.637-4.467 0-5.134 4.25-5.134 6.784 0 2.344 1.246 5.167 3.705 8.393-.486 1.472-1.028 3.09-1.65 4.948l-.406 1.211a34.86 34.86 0 0 1-1.161 3.003c-.325.146-.62.285-.9.424-1.189.59-2.3 1.114-3.374 1.62l-.09.043c-5.103 2.4-8.473 3.987-8.473 7.335 0 2.509 2.664 4.061 5.134 4.061 3.288 0 7.686-4.24 10.734-10.333 3.505-1.35 7.737-2.258 10.104-2.703 3.35 2.542 5.686 3.831 6.948 3.831 4.467 0 5.134-2.847 5.134-4.544 0-4.127-4.68-4.127-6.678-4.127z"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'icon-pdf',
    props: {
      width: {
        type: [Number, String],
        default: 82
      },
      height: {
        type: [Number, String],
        default: 100
      },
      iconColor: {
        type: String,
        default: 'currentColor'
      }
    }
  };
</script>
